export default __webpack_public_path__ + "static/media/light-through-trees-above.bcefcae4.gif";